export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7206.92a44e1c.jpg";